
export const urlPrefix = '/';

export const routes = {
    main: `${urlPrefix}`,
    home: `${urlPrefix}`,
    logout: `${urlPrefix}logout`,
    contact_us: `${urlPrefix}contact-us`,
    privacy_policy: `${urlPrefix}privacy-policy`,
    terms_and_conditions: `${urlPrefix}terms-and-conditions`,
   

    index:`${urlPrefix}index`,
    userLayout:`${urlPrefix}mainLayout`,
    orgReg:`${urlPrefix}mainLayout${urlPrefix}organisation-registration`,
    orgRegpayment:`${urlPrefix}mainLayout${urlPrefix}registrationpayment`,
    OrgPrint:`${urlPrefix}mainLayout${urlPrefix}orgPrint`,
    adminLayout:`${urlPrefix}adminLayout`,

    eventReg:`${urlPrefix}mainLayout${urlPrefix}create-event`,
    eventViewEdit:`${urlPrefix}mainLayout${urlPrefix}event-view-edit`,
    eventDocInfo:`${urlPrefix}mainLayout${urlPrefix}event-doc-info`,

    
    payment: `${urlPrefix}payment`,
    paymentsuccess: `${urlPrefix}paymentsuccess`,
    payment_failure: `${urlPrefix}payment_failure`,
    paymenterror: `${urlPrefix}paymentsuccess`,
    admin_Org_approvals: `${urlPrefix}adminLayout${urlPrefix}admin-org-approvals`,
    admin_Event_approvals: `${urlPrefix}adminLayout${urlPrefix}admin-event-approvals`,
    admin_doctor_approvals: `${urlPrefix}adminLayout${urlPrefix}admin-doctor-approvals`,
    admin_docPrint:`${urlPrefix}adminLayout${urlPrefix}docPrint`,
    admin_CpdCertPrint:`${urlPrefix}adminLayout${urlPrefix}CpdCertPrint`,
    admin_failed_emails: `${urlPrefix}adminLayout${urlPrefix}failed-emails`,
    admin_settings: `${urlPrefix}adminLayout${urlPrefix}settings`,
    admin_logout: `${urlPrefix}adminLayout${urlPrefix}logout`,
    admin_login: `${urlPrefix}admin`,
    doctor_search: `${urlPrefix}doctorsearch`,
    capture_photo: `${urlPrefix}mainLayout${urlPrefix}capture-photo`,
    admin_upcoming_form:`${urlPrefix}adminLayout${urlPrefix}upcoming-form`,
};
